module Eseebase {
    export interface IDragFileScope extends ng.IScope {
        fileId: string;
        acceptedExtensions: string;
        showUnitSelector: boolean;
        showLocalizer: boolean;
        showApartment: boolean;
        usePhotoUploadFilters: boolean;
        allowHyperlinks: boolean;
        multipleLocalizers: boolean;
        uploadStart: Function;
        selectFile: Function;
        selectLink: Function;
        fileSelected: Function;
        linkSelected: Function;
        uniqueId: string;
    }

    export class DragFileDirective {
        public link: (scope: IDragFileScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => void;
        public templateUrl = '/app/directives/drag-upload.html';
        public scope = {
            uploadStart: '&',
            fileId: '=',
            acceptedExtensions: '=',
            showUnitSelector: '=',
            showLocalizer: '=',
            showApartment: '=',
            usePhotoUploadFilters: '=',
            uniqueId: '=',
            allowHyperlinks: '=',
            linkSelected: '&',
            multipleLocalizers: '='
        };
        public require: string;
        public uploadStart: string;
        public organizations: OrganizationalUnitViewModel[];
        public features: CompanyFeatureList;
        public showUnitSelector: boolean;
        public showLocalizer: boolean;
        public showApartment: boolean;
        public usePhotoUploadFilters: boolean;
        public multipleLocalizers: boolean;

        constructor(private $http: ng.IHttpService, 
                    private $mdDialog: any, 
                    private organizationService: OrganizationService, 
                    private organizationSettingsService: OrganizationSettingsService, 
                    private $q: ng.IQService, 
                    private fileService: FileService, 
                    private buildingService: BuildingService)
        {
            var vm = this;
            DragFileDirective.prototype.scope = {
                uploadStart: '&',
                fileId: '=',
                acceptedExtensions: '=',
                showUnitSelector: '=',
                showLocalizer: '=',
                showApartment: '=',
                usePhotoUploadFilters: '=',
                uniqueId: '=',
                allowHyperlinks: '=',
                linkSelected: '&',
                multipleLocalizers: '='
            };
            DragFileDirective.prototype.link = (scope: IDragFileScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => {
                scope.$on('onCompanySelect', () => {
                    vm.getOrganizations();
                });
                vm.getOrganizations();
                element.on('dragover', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                });
                element.on('dragenter', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                });
                element.on('drop', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    if ((<any>e.originalEvent).dataTransfer) {
                        var dataTransfer = (<any>e.originalEvent).dataTransfer;
                        if (dataTransfer != null && dataTransfer.types != null && dataTransfer.types.length > 0 && dataTransfer.types[0] == "Files") {
                            doUpload((<any>e.originalEvent).dataTransfer, scope.uploadStart, scope.fileId);
                        }
                        else if (scope.allowHyperlinks && dataTransfer != null && dataTransfer.types != null && dataTransfer.types.length > 0 && dataTransfer.types[0] == "text/plain") {
                            dataTransfer.items[0].getAsString((s) => {
                                if (validateHyperlink(s)) {
                                    hyperlinkDialog(s);
                                }
                            });
                        }
                    }
                    return false;
                });

                vm.showUnitSelector = scope.showUnitSelector;
                vm.showLocalizer = scope.showLocalizer;
                vm.showApartment = scope.showApartment;
                vm.usePhotoUploadFilters = scope.usePhotoUploadFilters;
                vm.multipleLocalizers = scope.multipleLocalizers;

                function validateFiles(files: Array<any>) {
                    if (scope.acceptedExtensions == '.*') {
                        return true;
                    }
                    
                    var extensions = scope.acceptedExtensions.split(',');
                    if (extensions != null) {
                        for (var i = 0; i < files.length; i++) {
                            var extension = '.' + files[i].name.split('.').pop().toLowerCase();
                            if (extensions.indexOf(extension) == -1) {
                                return false;
                            }
                        }
                    }
                    return true;
                }

                function validateHyperlink(link: string) {
                    if (link == null || link == '') {
                        return false;
                    }
                    return /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/.test(link);
                }

                function doUpload(sender, uploadStart, fileId) {
                    if (sender != null && sender.files.length > 0 && validateFiles(sender.files)) {
                        upload(sender.files, scope.uploadStart, scope.fileId).then(() => sender.value = null);
                    }
                }

                function addHyperlink(link) {
                    if (validateHyperlink(link)) {
                        hyperlinkDialog(link);
                    }
                }

                function upload(files: any[], uploadStart, fileId) {
                    var d = vm.$q.defer();
                    var data = new FormData();
                    angular.forEach(files, function (value) {
                        data.append("files[]", value);
                    });
                    var fileArray = [];
                    for (var f of files) {
                        fileArray.push(f.name);
                    }

                    vm.$mdDialog.show({
                        controller: DragFileDirective.FileUpladDialogController(vm, scope, null),
                        controllerAs: 'vm',
                        templateUrl: '/app/dialog/organization-select.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: false
                    }).then((dialogData) => {
                        if (uploadStart) {
                            var args = new UploadEventArgs();
                            args.formData = data;
                            args.companyNumber = dialogData.ass.companyNumber;
                            args.associationNumber = dialogData.ass.number;
                            args.departmentNumber = dialogData.dep.number;
                            args.associationId = dialogData.ass.id;
                            args.departmentId = dialogData.dep.id;
                            args.extractSelectedUnits = dialogData.ext;
                            args.extractOnlySimData = dialogData.extSim;
                            args.fileId = fileId;
                            args.fileNames = fileArray;
                            args.localizer = dialogData.localizer;
                            args.apartmentNumber = dialogData.apartmentNumber;
                            uploadStart({ 'args': args });
                        }
                        d.resolve();
                    }, () => { d.resolve(); });
                    return d.promise;
                }

                function hyperlinkDialog(link: string) {
                    var d = vm.$q.defer();

                    vm.$mdDialog.show({
                        controller: DragFileDirective.FileUpladDialogController(vm, scope, link),
                        controllerAs: 'vm',
                        templateUrl: '/app/dialog/organization-select.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose: false
                    }).then((dialogData) => {
                        if (scope.linkSelected && validateHyperlink(dialogData.hyperlink)) {
                            var args = new UploadEventArgs();
                            args.hyperlink = dialogData.hyperlink;
                            args.companyNumber = dialogData.ass.companyNumber;
                            args.associationNumber = dialogData.ass.number;
                            args.departmentNumber = dialogData.dep.number;
                            args.associationId = dialogData.ass.id;
                            args.departmentId = dialogData.dep.id;
                            args.localizer = dialogData.localizer;
                            args.apartmentNumber = dialogData.apartmentNumber;
                            scope.linkSelected({ 'args': args });
                        }
                        d.resolve();
                    }, () => { d.resolve(); });
                    return d.promise;
                }

                scope.selectLink = function () {
                    hyperlinkDialog('');
                }

                scope.selectFile = function () {
                    if (scope.uniqueId != null) {
                        $("#fileUpload" + scope.uniqueId).click();
                    }
                    else {
                        $("#fileUpload").click();
                    }
                }

                scope.fileSelected = function(sender)
                {
                    doUpload(sender, scope.uploadStart, scope.fileId);
                }
            };
        }

        public getOrganizations() {
            var vm = this;
            this.organizationService.list().then((response: OrganizationalUnitViewModel[]) => {
                this.organizations = response;
            });
            this.organizationSettingsService.getFeatures().then((response: CompanyFeatureList) => {
                this.features = response;
            });
        }

        public static FileUpladDialogController = (vm: DragFileDirective, scope: IDragFileScope, link: string) => {
            return function () {
                this.$mdDialog = vm.$mdDialog;
                this.organizations = vm.organizations;
                this.showUnitSelector = scope.showUnitSelector;
                this.showLocalizer = scope.showLocalizer;
                this.showApartment = scope.showApartment;
                this.usePhotoUploadFilters = scope.usePhotoUploadFilters;
                this.multipleLocalizers = scope.multipleLocalizers;
                this.uniqueId = scope.uniqueId;
                if (link != null) {
                    this.showHyperlink = true;
                    this.hyperlink = link;
                }
                var self = this;
                this.onDepartmentSelected = function () {
                    if (scope.showLocalizer) {
                        self.selectedLocalizer = null;
                        if (self.selectedDepartment == null || self.selectedDepartment == '?') {
                            self.localizers = [];
                        }
                        else {
                            var filter = new ModelFilterViewModel();
                            filter.association.values = [self.selectedAssociation.id];
                            filter.department.values = [self.selectedDepartment.id];
                            vm.fileService.getLocalizers(filter).then((data) => {
                                self.localizers = data;
                            });
                        }
                    }
                };
                this.onLocalizerSelected = function () {
                    if (scope.showApartment) {
                        self.selectedApartment = null;
                        if (self.selectedLocalizer == null || self.selectedLocalizer == '?') {
                            self.apartments = [];
                        }
                        else {
                            var filter = new ModelFilterViewModel();
                            filter.association.values = [self.selectedAssociation.id];
                            filter.department.values = [self.selectedDepartment.id];
                            filter.localizer.values = [self.selectedLocalizer];
                            vm.fileService.getApartments(filter).then((data) => {
                                self.apartments = data;
                            });
                        }
                    }
                };
                this.isAssociationDisabled = function(associationId: string) {
                    if ((scope.uniqueId == 'scannedImages' && !vm.features.includeScannedImages([associationId])) ||
                        (scope.uniqueId == 'universalStorage' && !vm.features.includeUniversalStorage([associationId])))
                    {
                        return true;
                    }
                    return false;
                };

                var filters = scope.usePhotoUploadFilters ? vm.buildingService.getPhotoUploadFilters() : vm.buildingService.getFilters();
                
                if (filters.association.values != null && filters.association.values.length == 1) {
                    this.selectedAssociation = this.organizations.filter(f => f.id == filters.association.values[0])[0];
                    if (filters.department.values != null && filters.department.values.length == 1) {
                        this.selectedDepartment = this.selectedAssociation.children.filter(f => f.id == filters.department.values[0])[0];
                        this.onDepartmentSelected();
                        if (filters.localizer.values != null && filters.localizer.any()) {
                            this.selectedLocalizer = scope.multipleLocalizers ? filters.localizer.values : filters.localizer.values[0];
                            this.onLocalizerSelected();
                            if (filters.apartment.values != null && filters.apartment.any()) {
                                this.selectedApartment = scope.multipleLocalizers ? filters.apartment.values : filters.apartment.values[0];
                            }
                        }
                    }
                }
            }
        };

        public static Factory() {
            var directive = ($http: ng.IHttpService, 
                             $mdDialog: any, 
                             organizationService: OrganizationService, 
                             organizationSettingsService: OrganizationSettingsService, 
                             $q: ng.IQService, 
                             fileService: FileService, 
                             buildingService: BuildingService) => {
                return new DragFileDirective($http, $mdDialog, organizationService, organizationSettingsService, $q, fileService, buildingService);
            };

            directive['$inject'] = ['$http', '$mdDialog', 'OrganizationService', 'OrganizationSettingsService', '$q', 'FileService', 'BuildingService'];

            return directive;
        }
    }

    angular
        .module('eseebase')
        .directive('dragFile', DragFileDirective.Factory());
}